var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 10.5V8.5C17 5.73858 14.7614 3.5 12 3.5C9.23858 3.5 7 5.73858 7 8.5V10.5M12 15V17M8.8 21.5H15.2C16.8802 21.5 17.7202 21.5 18.362 21.173C18.9265 20.8854 19.3854 20.4265 19.673 19.862C20 19.2202 20 18.3802 20 16.7V15.3C20 13.6198 20 12.7798 19.673 12.138C19.3854 11.5735 18.9265 11.1146 18.362 10.827C17.7202 10.5 16.8802 10.5 15.2 10.5H8.8C7.11984 10.5 6.27976 10.5 5.63803 10.827C5.07354 11.1146 4.6146 11.5735 4.32698 12.138C4 12.7798 4 13.6198 4 15.3V16.7C4 18.3802 4 19.2202 4.32698 19.862C4.6146 20.4265 5.07354 20.8854 5.63803 21.173C6.27976 21.5 7.11984 21.5 8.8 21.5Z",
    stroke: "#98A2B3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.35b0c8c9b11694e6ca63633fab9078e7.svg";
export { ForwardRef as ReactComponent };